import { frontendURL } from '../../../helper/URLHelper';

import AgentsPageLayout from './pages/AgentsPageLayout.vue';
import AgentsList from './agents/AgentsList.vue';
import AgentCreate from './agents/AgentCreate.vue';
import AgentFlowCanvas from './agents/AgentFlowCanvas.vue';
import AgentRules from './rules/AgentRules.vue';
import ConnectorsList from './connectors/ConnectorsList.vue';

const meta = {
  permissions: ['administrator'],
};

const agentRoutes = [
  {
    path: '',
    name: 'ai_agents_list',
    component: AgentsList,
    meta,
  },
  {
    path: 'new',
    name: 'ai_agents_create',
    component: AgentCreate,
    meta,
  },
  {
    path: 'connectors',
    name: 'ai_connectors_list',
    component: ConnectorsList,
    meta,
  },
  {
    // O Fluxo é o hub do agente: /ai-agents/:agentId vai pro flow
    path: ':agentId',
    redirect: to => ({
      name: 'ai_agents_flow',
      params: to.params,
    }),
  },
  {
    // Settings foi consolidado no Fluxo (aba Configurações) — redireciona
    path: ':agentId/settings',
    name: 'ai_agents_settings',
    redirect: to => ({
      name: 'ai_agents_flow',
      params: to.params,
    }),
  },
  {
    path: ':agentId/flow',
    name: 'ai_agents_flow',
    component: AgentFlowCanvas,
    meta,
  },
  {
    // Caixas agora ficam na aba Lançamento do Fluxo — abre direto nela.
    path: ':agentId/inboxes',
    name: 'ai_agents_inboxes',
    redirect: to => ({
      name: 'ai_agents_flow',
      params: to.params,
      query: { tab: 'launch' },
    }),
  },
  {
    path: ':agentId/rules',
    name: 'ai_agents_rules',
    component: AgentRules,
    meta,
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ai-agents'),
    component: AgentsPageLayout,
    redirect: to => ({
      name: 'ai_agents_list',
      params: to.params,
    }),
    children: agentRoutes,
  },
];

export default { routes };
